import React from 'react'
import './Header.css'

export default props => 
    <header>
        <h1>Bingo</h1>
    </header>